function hasOwnProperty<T extends object, K extends keyof T>(obj: T, key: K): obj is T & { [P in K]-?: T[P] };
function hasOwnProperty<K extends string>(obj: unknown, key: K): obj is { [P in K]: unknown };
function hasOwnProperty<K extends string>(obj: unknown, ...keys: K[]): obj is { [P in K]: unknown };
function hasOwnProperty<K extends string>(obj: unknown, ...keys: K[]): obj is { [P in K]: unknown } {
    return !!obj && keys.every(k => Object.prototype.hasOwnProperty.call(obj, k));
}

function isPropertyOf<T extends object>(key: PropertyKey, obj: T): key is keyof T {
    return !!obj && Object.prototype.hasOwnProperty.call(obj, key);
}

export { hasOwnProperty, isPropertyOf };
